/**
 * Created by amir on 8/26/18.
 */

export default class UserCodeService {

    constructor() {
        this.userCode = null;
    }

    saveUserCode(userCode){
        this.userCode = userCode;
    }

    getUserCode(){
        return this.userCode;
    }

    deleteUserCode(){
        this.userCode = null;
    }
}


/** WEBPACK FOOTER **
 ** ./src/services/app/userCode.service.js
 **/